import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SchemaService } from 'src/app/shared/symptoms/services/schema/schema.service';
import { ClinicSetupService } from '../../clinic-setup.service';
import { Layout, LayoutsService } from '../layouts.service';

@Component({
  selector: 'csi-day-sheet-signs-setup',
  templateUrl: './day-sheet-signs-setup.component.html'
})
export class DaySheetSignsSetupComponent {
  @Input() layout: Layout;
  @Input() layoutFormControl: FormControl;
  @Input() isSaving: boolean;
  @Input() maxShow: number | null = null;
  @Input() preventShowOverride: string[] = [];

  public readonly signsMap = this.schemaService.symptomMap;

  constructor(
    private schemaService: SchemaService,
    private layoutsService: LayoutsService,
    public clinicSetupService: ClinicSetupService
  ) {}

  get showSignKeys(): string[] {
    const v = this.layoutFormControl && this.layoutFormControl.value;
    const sl = v && v.signsLayout;
    return (sl && sl.show) || [];
  }

  getEyeMode(signKey: string): string {
    const v = this.layoutFormControl && this.layoutFormControl.value;
    const sl = v && v.signsLayout;
    const em = (sl && sl.eyeMode) || {};
    return em[signKey] || 'OD_OS';
  }

  setEyeMode(signKey: string, mode: string): void {
    const v = this.layoutFormControl && this.layoutFormControl.value;
    const signsLayout = (v && v.signsLayout) || {};
    const eyeMode = { ...(signsLayout.eyeMode || {}), [signKey]: mode };
    this.layoutsService.updateLayoutFormControlValue(
      this.layoutFormControl,
      'signsLayout',
      { ...signsLayout, eyeMode }
    );
  }
}
